// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/experiment_plex_parameter_overrides.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssayLimits } from "./assay_limits_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_assay_limits } from "./assay_limits_pb";
import type { CurveParameterOptions } from "./curve_parameter_options_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_curve_parameter_options } from "./curve_parameter_options_pb";
import type { ExperimentExcludedReplicates } from "./experiment_excluded_replicates_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_excluded_replicates } from "./experiment_excluded_replicates_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/experiment_plex_parameter_overrides.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_experiment_plex_parameter_overrides: GenFile = /*@__PURE__*/
  fileDesc("ClFxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvZXhwZXJpbWVudF9wbGV4X3BhcmFtZXRlcl9vdmVycmlkZXMucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSKYAwogRXhwZXJpbWVudFBsZXhQYXJhbWV0ZXJPdmVycmlkZXMSDwoHcGxleF9pZBgBIAEoCRJPCgxhc3NheV9saW1pdHMYAiABKAsyNC5xdWFudGVyaXguc2ltb2Ffb25lLmFuYWx5c2lzX2FwcF9hcGkudjEuQXNzYXlMaW1pdHNIAIgBARJkChdjdXJ2ZV9wYXJhbWV0ZXJfb3B0aW9ucxgDIAEoCzI+LnF1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MS5DdXJ2ZVBhcmFtZXRlck9wdGlvbnNIAYgBARJnChNleGNsdWRlZF9yZXBsaWNhdGVzGAQgASgLMkUucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkV4cGVyaW1lbnRFeGNsdWRlZFJlcGxpY2F0ZXNIAogBAUIPCg1fYXNzYXlfbGltaXRzQhoKGF9jdXJ2ZV9wYXJhbWV0ZXJfb3B0aW9uc0IWChRfZXhjbHVkZWRfcmVwbGljYXRlc2IGcHJvdG8z", [file_quanterix_simoa_one_analysis_app_api_v1_assay_limits, file_quanterix_simoa_one_analysis_app_api_v1_curve_parameter_options, file_quanterix_simoa_one_analysis_app_api_v1_experiment_excluded_replicates]);

/**
 * Per-assay / per-plex experiment analysis setup
 * parameters to override assay protocol defaults and
 * exclude replicate data points (e.g. outliers)
 *
 * @remarks Equivalent to the quanterix.protos.data_management.v1 type
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.ExperimentPlexParameterOverrides
 */
export type ExperimentPlexParameterOverrides = Message<"quanterix.simoa_one.analysis_app_api.v1.ExperimentPlexParameterOverrides"> & {
  /**
   * Plex UUID
   *
   * @generated from field: string plex_id = 1;
   */
  plexId: string;

  /**
   * Overrides for AssayLimits (acceptance criteria)
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.AssayLimits assay_limits = 2;
   */
  assayLimits?: AssayLimits;

  /**
   * Overrides for CurveParameterOptions (curve fitting configuration)
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.CurveParameterOptions curve_parameter_options = 3;
   */
  curveParameterOptions?: CurveParameterOptions;

  /**
   * Collection of replicates to exclude from analysis
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentExcludedReplicates excluded_replicates = 4;
   */
  excludedReplicates?: ExperimentExcludedReplicates;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.ExperimentPlexParameterOverrides.
 * Use `create(ExperimentPlexParameterOverridesSchema)` to create a new message.
 */
export const ExperimentPlexParameterOverridesSchema: GenMessage<ExperimentPlexParameterOverrides> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_experiment_plex_parameter_overrides, 0);

